import type { ReactNode, SyntheticEvent } from "react";

import { ImageOff } from "lucide-react";
import { twMerge } from "tailwind-merge";

import { useImageFallback } from "@/hooks/useImagePreview";

export function DesignImage({
  alt,
  className,
  fallback,
  onLoad,
  sources,
}: {
  alt: string;
  className?: string;
  fallback?: ReactNode;
  onLoad?: (event: SyntheticEvent<HTMLImageElement>) => void;
  sources: string[];
}) {
  const { hasFailed, onError, src } = useImageFallback(sources);

  if (hasFailed || !src) {
    return (
      fallback ?? (
        <div
          className={twMerge(
            "flex items-center justify-center bg-bg-secondary text-fg-quaternary",
            className,
          )}
        >
          <ImageOff className="size-5" />
        </div>
      )
    );
  }

  return (
    <img
      alt={alt}
      className={className}
      onError={onError}
      onLoad={onLoad}
      src={src}
    />
  );
}
